import React, { useState } from "react";
import { Button, Form, Container, Row, Col, Table, Alert } from "react-bootstrap";

const ProductForm = () => {
  const [productData, setProductData] = useState({
    productName: "",
    cgst: "",
    sgst: "",
    mrp: "",
    sellPrice: "",
    dp: "",
    length: "",
    breadth: "",
    height: "",
    weight: "",
    productDescription: "",
    image: null,
  });

  const [productList, setProductList] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData({ ...productData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProductData({ ...productData, image: URL.createObjectURL(file) });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validating required fields
    if (productData.productName && productData.mrp && productData.sellPrice) {
      setProductList([...productList, productData]);
      setShowAlert(true); // Show success message
      setProductData({
        productName: "",
        cgst: "",
        sgst: "",
        mrp: "",
        sellPrice: "",
        dp: "",
        length: "",
        breadth: "",
        height: "",
        weight: "",
        productDescription: "",
        image: null,
      });
    } else {
      setShowAlert(false); // If validation fails
    }
  };

  const handleDelete = (index) => {
    const updatedList = productList.filter((_, i) => i !== index);
    setProductList(updatedList);
  };

  return (
    <Container className="mt-4">
      <h3 className="text-center mb-4">Create New Product</h3>

      {/* Success/Error Alert */}
      {showAlert !== null && (
        <Alert variant={showAlert ? "success" : "danger"}>
          {showAlert ? "Product added successfully!" : "Please fill out required fields."}
        </Alert>
      )}

      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="formProductName">
              <Form.Label>Product Name</Form.Label>
              <Form.Control
                type="text"
                name="productName"
                value={productData.productName}
                onChange={handleChange}
                placeholder="Enter Product Name"
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="formCGST">
              <Form.Label>CGST (%)</Form.Label>
              <Form.Control
                type="number"
                name="cgst"
                value={productData.cgst}
                onChange={handleChange}
                placeholder="Enter CGST"
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="formSGST">
              <Form.Label>SGST (%)</Form.Label>
              <Form.Control
                type="number"
                name="sgst"
                value={productData.sgst}
                onChange={handleChange}
                placeholder="Enter SGST"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="formMRP">
              <Form.Label>MRP</Form.Label>
              <Form.Control
                type="number"
                name="mrp"
                value={productData.mrp}
                onChange={handleChange}
                placeholder="Enter MRP"
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="formSellPrice">
              <Form.Label>Sell Price</Form.Label>
              <Form.Control
                type="number"
                name="sellPrice"
                value={productData.sellPrice}
                onChange={handleChange}
                placeholder="Enter Sell Price"
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="formDP">
              <Form.Label>DP</Form.Label>
              <Form.Control
                type="number"
                name="dp"
                value={productData.dp}
                onChange={handleChange}
                placeholder="Enter DP"
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={4}>
            <Form.Group controlId="formLength">
              <Form.Label>Length (cm)</Form.Label>
              <Form.Control
                type="number"
                name="length"
                value={productData.length}
                onChange={handleChange}
                placeholder="Enter Length"
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="formBreadth">
              <Form.Label>Breadth (cm)</Form.Label>
              <Form.Control
                type="number"
                name="breadth"
                value={productData.breadth}
                onChange={handleChange}
                placeholder="Enter Breadth"
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="formHeight">
              <Form.Label>Height (cm)</Form.Label>
              <Form.Control
                type="number"
                name="height"
                value={productData.height}
                onChange={handleChange}
                placeholder="Enter Height"
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="formWeight">
              <Form.Label>Weight (kg)</Form.Label>
              <Form.Control
                type="number"
                name="weight"
                value={productData.weight}
                onChange={handleChange}
                placeholder="Enter Weight"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="formProductDescription">
              <Form.Label>Product Description</Form.Label>
              <Form.Control
                as="textarea"
                name="productDescription"
                value={productData.productDescription}
                onChange={handleChange}
                placeholder="Enter Product Description"
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="formImage">
              <Form.Label>Product Image</Form.Label>
              <Form.Control
                type="file"
                name="image"
                onChange={handleImageChange}
                accept="image/*"
              />
              {productData.image && (
                <div className="mt-3">
                  <h5>Image Preview:</h5>
                  <img
                    src={productData.image}
                    alt="Product"
                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                  />
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Button variant="primary" type="submit" className="mt-3">
          Add Product
        </Button>
      </Form>

      {/* Product List Table */}
      <h3 className="mt-4 text-center">Product List</h3>
      <Table striped bordered hover responsive className="mt-3">
        <thead className="bg-light">
          <tr>
            <th>Product Name</th>
            <th>Image</th>
            <th>CGST (%)</th>
            <th>SGST (%)</th>
            <th>MRP</th>
            <th>Sell Price</th>
            <th>DP</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {productList.map((product, index) => (
            <tr key={index} className="hover-table-row">
              <td>{product.productName}</td>
              <td>
                {product.image && (
                  <img
                    src={product.image}
                    alt="Product"
                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                  />
                )}
              </td>
              <td>{product.cgst}</td>
              <td>{product.sgst}</td>
              <td>{product.mrp}</td>
              <td>{product.sellPrice}</td>
              <td>{product.dp}</td>
              <td>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(index)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default ProductForm;
